import { GetAuthenticatedDocUrl, GetSingleIRLDoc } from '../redux/documentsSlice';

/**
 * Resolve a workstream document to a URL the PDF viewer can load (SAS when Azure blob).
 */
export async function fetchAuthenticatedIrlDocumentUrl(dispatch, { wsId, docId }) {
    const ws = Number(wsId);
    const doc = Number(docId);
    if (!Number.isFinite(ws) || !Number.isFinite(doc)) {
        throw new Error('missing_ids');
    }

    const response = await dispatch(GetSingleIRLDoc({ wsId: ws, docId: doc }));
    if (response?.type !== 'IRLDOC/getSingleIRLDoc/fulfilled') {
        throw new Error('fetch_failed');
    }

    let docUrl = response?.payload?.data?.document;
    if (!docUrl || typeof docUrl !== 'string') {
        throw new Error('no_url');
    }

    if (docUrl.includes('.blob.core.windows.net')) {
        docUrl = await dispatch(GetAuthenticatedDocUrl(docUrl)).unwrap();
    }

    return docUrl;
}
